import { Component, EventEmitter, Input, Output } from '@angular/core'
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms'
import { NgFor } from '@angular/common';

@Component({
    selector: 'gd-rvradio',
    template: `
    <div [formGroup]="form">
      <div
        class="form-check"
        *ngFor="let opt of field.options"
        style="display:inline; padding:0px 5px 5px 20px"
      >
        <input
          class="form-check-input"
          (click)="valueChanged(opt.key)"
          [name]="field.name"
          type="radio"
          [attr.disabled]="field.disabled ? true : null"
          [formControlName]="field.name"
          [value]="opt.key"
        />
        <label class="form-check-label">
          {{ opt.label }}
        </label>
      </div>
    </div>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        NgFor,
    ]
})
export class RvRadioComponent {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  @Output() checkVals = new EventEmitter()

  valueChanged(k: any) {
    this.checkVals.emit(k)
  }
}
